import styled, { css } from 'styled-components'

import { Body } from 'components/Text'

export const ToggleButton = styled(Body)<{ $active: boolean }>`
	cursor: pointer;
	text-transform: capitalize;
	color: ${(props) => props.theme.colors.selectedTheme.newTheme.text.primary};

	&:hover {
		color: ${(props) => props.theme.colors.selectedTheme.newTheme.text.preview};
	}

	${(props) =>
		props.$active &&
		css`
			color: ${props.theme.colors.selectedTheme.newTheme.text.preview};
		`}
`
